/*
  Unified Auto-Correcting Search - Revline Used Auto Parts
  Single dropdown with: Suggestions → Recent Searches → Products
  Matches Redline Auto Parts style
*/

class UnifiedSearch {
  constructor() {
    // Find all search inputs - prioritize header search (desktop and mobile)
    this.searchInputs = [
      document.querySelector('.header__mobile-search-input'),
      document.querySelector('#mobile-search-input'),
      document.querySelector('.header__search [data-search-input]'),
      document.querySelector('.header__search input[name="q"]'),
      document.querySelector('[data-search-input]'),
      document.querySelector('[data-predictive-search-input]'),
      document.querySelector('input[name="q"]'),
      document.querySelector('.search-bar__input'),
      document.querySelector('.search-input')
    ].filter(Boolean);

    // Comprehensive automotive parts dictionary with common typos
    this.autoCorrectDictionary = {
      // Headlights & Lighting
      'hedlights': 'headlights', 'hedlight': 'headlight', 'headlites': 'headlights', 'headlite': 'headlight',
      'head lights': 'headlights', 'head light': 'headlight', 'hed light': 'headlight', 'hed lights': 'headlights',
      'tailights': 'taillights', 'tailight': 'taillight', 'taillites': 'taillights', 'taillite': 'taillight',
      'tail lights': 'taillights', 'tail light': 'taillight', 'tai light': 'taillight', 'tai lights': 'taillights',
      'fog light': 'foglight', 'fog lights': 'foglights', 'fog lite': 'foglight', 'fog lites': 'foglights',
      'brake light': 'brakelight', 'brake lights': 'brakelights', 'brake lite': 'brakelight', 'brake lites': 'brakelights',
      'head lamp': 'headlamp', 'head lamps': 'headlamps', 'tail lamp': 'taillamp', 'tail lamps': 'taillamps',
      'turn signal': 'turnsignal', 'turn signals': 'turnsignals', 'turn singal': 'turnsignal', 'turn singals': 'turnsignals',
      
      // Body Parts
      'bumer': 'bumper', 'bumpers': 'bumpers', 'bumper cover': 'bumper', 'bumper covers': 'bumpers',
      'fender': 'fender', 'fenders': 'fenders', 'fenda': 'fender', 'fendas': 'fenders',
      'hood': 'hood', 'hoods': 'hoods', 'hud': 'hood', 'trunk': 'trunk', 'trunks': 'trunks', 'trunck': 'trunk',
      'grill': 'grille', 'grille': 'grille', 'grills': 'grilles', 'grilles': 'grilles',
      'spoiler': 'spoiler', 'spoilers': 'spoilers', 'spoiler wing': 'spoiler', 'spoiler wings': 'spoilers',
      'running board': 'runningboard', 'running boards': 'runningboards', 'runing board': 'runningboard',
      'quarter pannel': 'quarter panel', 'quarter panel': 'quarterpanel', 'quarter pannels': 'quarter panels',
      
      // Doors & Windows
      'door handle': 'doorhandle', 'door handles': 'doorhandles', 'door handel': 'doorhandle',
      'door pannel': 'door panel', 'door panel': 'doorpanel', 'door pannels': 'door panels',
      'windshild': 'windshield', 'windshiel': 'windshield', 'wind shield': 'windshield',
      'windshild wiper': 'windshield wiper', 'windshild wipers': 'windshield wipers',
      'windshield wiper': 'windshieldwiper', 'windshield wipers': 'windshieldwipers',
      'window regulator': 'windowregulator', 'window regulater': 'windowregulator',
      
      // Mirrors
      'side miror': 'side mirror', 'side mirror': 'sidemirror', 'side mirors': 'side mirrors',
      'side mirrors': 'sidemirrors', 'rear view miror': 'rearview mirror', 'rear view mirror': 'rearview mirror',
      'rearview miror': 'rearview mirror', 'miror': 'mirror', 'mirors': 'mirrors',
      
      // Engine Parts
      'engin': 'engine', 'engines': 'engines', 'engin block': 'engine block',
      'engin mount': 'engine mount', 'engine mount': 'enginemount', 'engin mounts': 'engine mounts',
      'radiator': 'radiator', 'radiators': 'radiators', 'radiatar': 'radiator',
      'alternator': 'alternator', 'alternators': 'alternators', 'altenator': 'alternator', 'altanator': 'alternator',
      'starter': 'starter', 'starters': 'starters', 'startar': 'starter',
      'water pump': 'waterpump', 'water pum': 'waterpump', 'oil pump': 'oilpump', 'oil pum': 'oilpump',
      'timing belt': 'timingbelt', 'timing bel': 'timingbelt', 'timing chain': 'timingchain',
      'fuel pump': 'fuelpump', 'fuel pum': 'fuelpump', 'spark plug': 'sparkplug', 'spark plu': 'sparkplug',
      'air filter': 'airfilter', 'air filer': 'airfilter', 'oil filter': 'oilfilter', 'oil filer': 'oilfilter',
      'transmission': 'transmission', 'transmissions': 'transmissions', 'transmision': 'transmission',
      'clutch': 'clutch', 'clutches': 'clutches', 'cluch': 'clutch',
      
      // Suspension & Steering
      'shock absorber': 'shockabsorber', 'shock absorbers': 'shockabsorbers', 'shok absorber': 'shockabsorber',
      'shock': 'shock', 'shocks': 'shocks', 'shok': 'shock', 'strut': 'strut', 'struts': 'struts',
      'coilover': 'coilover', 'coilovers': 'coilovers', 'coil over': 'coilover', 'coil overs': 'coilovers',
      'control arm': 'controlarm', 'contol arm': 'controlarm', 'sway bar': 'swaybar', 'swa bar': 'swaybar',
      'tie rod': 'tierod', 'tie ro': 'tierod', 'ball joint': 'balljoint', 'bal joint': 'balljoint',
      
      // Brakes
      'brake pad': 'brakepad', 'brake pads': 'brakepads', 'brak pad': 'brakepad',
      'brake rotor': 'brakerotor', 'brak rotor': 'brakerotor', 'brake disc': 'brakedisc',
      'brake caliper': 'brakecaliper', 'brak caliper': 'brakecaliper', 'brake line': 'brakeline', 'brak line': 'brakeline',
      
      // Wheels & Tires
      'rims': 'wheels', 'rim': 'wheel', 'wheel': 'wheel', 'wheels': 'wheels',
      'wheel hub': 'wheelhub', 'wheel bearing': 'wheelbearing', 'whel bearing': 'wheelbearing',
      'tire': 'tire', 'tires': 'tires', 'tyre': 'tire', 'tyres': 'tires',
      
      // Exhaust
      'exhaust pipe': 'exhaustpipe', 'exaust pipe': 'exhaustpipe', 'muffler': 'muffler', 'mufle': 'muffler',
      'catalytic converter': 'catalyticconverter', 'catalytic convertor': 'catalyticconverter',
      
      // Interior
      'dashboard': 'dashboard', 'dashboards': 'dashboards', 'dash board': 'dashboard',
      'center console': 'centerconsole', 'centre console': 'centerconsole', 'center consol': 'centerconsole',
      'seat': 'seat', 'seats': 'seats', 'seet': 'seat', 'steering wheel': 'steeringwheel', 'steering whel': 'steeringwheel',
      'air bag': 'airbag', 'seat belt': 'seatbelt', 'seet belt': 'seatbelt', 'floor mat': 'floormat', 'flor mat': 'floormat',
      
      // Electrical
      'battery': 'battery', 'batteries': 'batteries', 'batry': 'battery',
      'fuse box': 'fusebox', 'fuz box': 'fusebox', 'relay': 'relay', 'relays': 'relays', 'rela': 'relay',
      'ecu': 'ecu', 'ecus': 'ecus', 'e c u': 'ecu',
      
      // Cooling
      'thermostat': 'thermostat', 'thermostats': 'thermostats', 'thermosta': 'thermostat',
      'coolant hose': 'coolanthose', 'coolant hos': 'coolanthose', 'radiator hose': 'radiatorhose',
      
      // Drivetrain
      'drive shaft': 'driveshaft', 'driveshaft': 'driveshaft', 'cv axle': 'cvaxle', 'c v axle': 'cvaxle',
      'cv joint': 'cvjoint', 'c v joint': 'cvjoint', 'differential': 'differential', 'diferential': 'differential',
      'axle': 'axle', 'axles': 'axles', 'axel': 'axle'
    };

    // Popular searches
    this.popularSearches = [
      'headlights', 'taillights', 'fog lights', 'brake lights', 'turn signals',
      'bumper', 'fender', 'hood', 'trunk', 'grille', 'spoiler', 'running board',
      'door handle', 'door panel', 'windshield', 'windshield wiper', 'window regulator',
      'side mirror', 'rearview mirror', 'door mirror',
      'engine', 'alternator', 'starter', 'radiator', 'water pump', 'timing belt',
      'fuel pump', 'spark plug', 'air filter', 'oil filter',
      'transmission', 'clutch', 'flywheel',
      'shock', 'strut', 'coilover', 'spring', 'control arm', 'sway bar',
      'brake pad', 'brake rotor', 'brake caliper', 'brake line',
      'wheels', 'rims', 'tires', 'wheel bearing',
      'muffler', 'exhaust pipe', 'catalytic converter',
      'dashboard', 'center console', 'seat', 'steering wheel', 'air bag',
      'battery', 'alternator', 'starter', 'fuse box',
      'radiator', 'thermostat', 'coolant hose',
      'drive shaft', 'cv axle', 'differential'
    ];

    this.recentSearches = this.loadRecentSearches();
    this.isSearching = false;

    if (this.searchInputs.length > 0) {
      this.init();
    }
  }

  init() {
    this.searchInputs.forEach(input => {
      this.setupInput(input);
    });
    
    // Ensure all dropdowns are hidden on initialization
    const allContainers = document.querySelectorAll('.unified-search-results, #search-results, #mobile-search-results');
    allContainers.forEach(container => {
      this.hideResults(container);
    });
  }

  setupInput(input) {
    const form = input.closest('form');
    const unifiedContainer = this.getUnifiedContainer(input, form);
    const clearButton = input.closest('.header__search')?.querySelector('#search-clear') ||
                        input.closest('form')?.querySelector('.search-clear') ||
                        input.closest('form')?.querySelector('[id*="clear"]');

    let searchTimeout = null;

    // Show/hide clear button
    const updateClearButton = () => {
      if (clearButton) {
        if (input.value.trim().length > 0) {
          clearButton.style.display = 'flex';
        } else {
          clearButton.style.display = 'none';
        }
      }
    };

    // Clear button handler
    if (clearButton) {
      clearButton.addEventListener('click', (e) => {
        e.preventDefault();
        input.value = '';
        input.focus();
        this.hideResults(unifiedContainer);
        updateClearButton();
      });
    }

    // Unified input handler - only show if hovering or focused
    input.addEventListener('input', this.debounce((e) => {
      const query = e.target.value.trim();
      updateClearButton();
      
      // Only show dropdown if input is focused or mouse is hovering
      const isHovering = input.matches(':hover') || (form && form.matches(':hover'));
      const isFocused = document.activeElement === input;
      
      if (!isHovering && !isFocused) {
        this.hideResults(unifiedContainer);
        return;
      }
      
      if (query.length === 0) {
        if (isHovering || isFocused) {
          this.showEmptyState(input, unifiedContainer);
        }
        return;
      }
      
      // Show suggestions even for 1 character - don't wait
      clearTimeout(searchTimeout);
      if (query.length === 1) {
        // Immediate suggestions for single character
        this.performUnifiedSearch(query, input, unifiedContainer);
      } else {
        // Debounced search for longer queries
        searchTimeout = setTimeout(() => {
          this.performUnifiedSearch(query, input, unifiedContainer);
        }, 300);
      }
    }, 150));

    // Focus handler - show dropdown on focus
    input.addEventListener('focus', () => {
      const query = input.value.trim();
      updateClearButton();
      if (query.length >= 2) {
        this.performUnifiedSearch(query, input, unifiedContainer);
      } else {
        this.showEmptyState(input, unifiedContainer);
      }
    });
    
    // Blur handler - close when input loses focus (unless clicking dropdown)
    input.addEventListener('blur', (e) => {
      // Small delay to allow click events on dropdown items to fire first
      setTimeout(() => {
        // Check if focus moved to dropdown or form elements
        const activeElement = document.activeElement;
        const isClickingDropdown = unifiedContainer.contains(activeElement) || 
                                   form?.contains(activeElement);
        
        // Also check if mouse is still hovering
        const isHovering = input.matches(':hover') || (form && form.matches(':hover')) || 
                          unifiedContainer.matches(':hover');
        
        if (!isClickingDropdown && !isHovering) {
          this.hideResults(unifiedContainer);
        }
      }, 150);
    });

    // Form submission
    if (form) {
      form.addEventListener('submit', (e) => {
        const query = input.value.trim();
        if (query.length >= 2) {
          const corrected = this.autoCorrect(query);
          if (corrected !== query) {
            input.value = corrected;
          }
          this.saveRecentSearch(corrected || query);
        }
      });
    }

    // Escape key
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideResults(unifiedContainer);
        input.blur();
      }
    });


    // Hover and mouse leave handlers - show on hover, hide when mouse leaves
    const searchArea = form || input.parentElement;
    if (searchArea) {
      // Show dropdown on hover (only if not already hidden)
      searchArea.addEventListener('mouseenter', () => {
        // Only show if user is actively hovering (not just page load)
        const query = input.value.trim();
        if (query.length >= 2) {
          this.performUnifiedSearch(query, input, unifiedContainer);
        } else if (query.length === 0) {
          this.showEmptyState(input, unifiedContainer);
        }
      });
      
      // Close when mouse leaves search area
      searchArea.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget;
        // Close if mouse left search area and didn't go to dropdown
        if (!unifiedContainer.contains(relatedTarget)) {
          this.hideResults(unifiedContainer);
        }
      });
    }
    
    // Mouse leave on dropdown - close when mouse leaves dropdown
    unifiedContainer.addEventListener('mouseleave', (e) => {
      const relatedTarget = e.relatedTarget;
      // Close if mouse left dropdown and didn't go back to search area
      if (!searchArea?.contains(relatedTarget) && !unifiedContainer.contains(relatedTarget)) {
        this.hideResults(unifiedContainer);
      }
    });
    
    // Touch/click outside handler for mobile - close when clicking outside
    const handleMobileClose = (e) => {
      const isMobile = window.innerWidth <= 749;
      if (isMobile && unifiedContainer.classList.contains('is-visible')) {
        const clickedInside = searchArea?.contains(e.target) || 
                             unifiedContainer.contains(e.target) ||
                             input === e.target ||
                             (input && input.contains && input.contains(e.target));
        
        if (!clickedInside) {
          this.hideResults(unifiedContainer);
        }
      }
    };
    
    // Add touch/click outside listeners for mobile
    if (window.innerWidth <= 749) {
      document.addEventListener('click', handleMobileClose, true);
      document.addEventListener('touchstart', handleMobileClose, true);
      
      // Store handler for cleanup
      unifiedContainer._mobileCloseHandler = handleMobileClose;
    }

    // Click outside to close - use a single global handler
    if (!this.clickOutsideHandler) {
      this.clickOutsideHandler = (e) => {
        // Check all search containers
        const allContainers = document.querySelectorAll('.unified-search-results.is-visible, #search-results.is-visible, #mobile-search-results.is-visible');
        const allInputs = document.querySelectorAll('[data-search-input], .header__mobile-search-input, #mobile-search-input, .search-input');
        
        let clickedInside = false;
        
        // Check if click is inside any search container or input
        allContainers.forEach(container => {
          if (container.contains(e.target)) {
            clickedInside = true;
          }
        });
        
        allInputs.forEach(searchInput => {
          if (searchInput === e.target || searchInput.contains(e.target)) {
            clickedInside = true;
          }
        });
        
        // Check if click is on form elements (buttons, etc.)
        allInputs.forEach(searchInput => {
          const searchForm = searchInput.closest('form');
          if (searchForm && searchForm.contains(e.target)) {
            clickedInside = true;
          }
        });
        
        // If clicked outside, hide all visible containers
        if (!clickedInside) {
          allContainers.forEach(container => {
            this.hideResults(container);
          });
        }
      };
      
      // Add single global click handler
      document.addEventListener('click', this.clickOutsideHandler, true);
    }
  }

  getUnifiedContainer(input, form) {
    // Priority: Use existing #search-results container - check mobile first, then desktop
    const isMobileInput = input.classList.contains('header__mobile-search-input') || 
                         input.id === 'mobile-search-input' ||
                         input.closest('.header__mobile-search');
    
    let container = isMobileInput 
      ? (document.querySelector('#mobile-search-results') ||
         input.closest('.header__mobile-search')?.querySelector('#mobile-search-results') ||
         input.closest('form')?.querySelector('#mobile-search-results'))
      : (document.querySelector('#search-results') ||
         input.closest('.header__search')?.querySelector('#search-results'));
    
    // Fallback to other containers
    if (!container) {
      container = input.closest('.search-bar')?.querySelector('[data-predictive-search-results]') ||
                  input.closest('form')?.querySelector('.search-results') ||
                  document.querySelector('[data-predictive-search-results]');
    }

    if (!container) {
      // Create unified container as fallback
      container = document.createElement('div');
      container.className = 'unified-search-results search-results';
      
      // Use mobile ID if mobile input, otherwise desktop ID
      if (isMobileInput) {
        container.id = 'mobile-search-results';
      } else {
        container.id = 'search-results';
      }
      
      container.setAttribute('aria-hidden', 'true');
      container.setAttribute('role', 'listbox');
      
      const content = document.createElement('div');
      content.className = 'search-results__content';
      container.appendChild(content);
      
      // For mobile, append to form for proper positioning
      const isMobile = window.innerWidth <= 749 || isMobileInput;
      if (isMobile && form) {
        form.style.position = 'relative';
        form.appendChild(container);
      } else if (form) {
        form.style.position = 'relative';
        form.appendChild(container);
      } else if (input.parentElement) {
        input.parentElement.style.position = 'relative';
        input.parentElement.appendChild(container);
      }
    }

    // Mark as unified search container - CRITICAL for CSS
    container.classList.add('unified-search-results');
    
    // Ensure it's not hidden by default styles
    container.style.opacity = '1';
    container.style.visibility = 'visible';
    container.style.transform = 'translateY(0)';
    
    // Mobile positioning
    const isMobile = window.innerWidth <= 749;
    if (isMobile && input) {
      const rect = input.getBoundingClientRect();
      container.style.position = 'fixed';
      container.style.top = (rect.bottom + window.scrollY) + 'px';
      container.style.left = '0';
      container.style.right = '0';
      container.style.width = '100%';
      container.style.zIndex = '99999';
    }
    
    // Hide any other search result containers
    document.querySelectorAll('[data-search-results]:not(#search-results), .search-results.is-open:not(.unified-search-results)').forEach(el => {
      if (el !== container) {
        el.style.display = 'none';
        el.style.opacity = '0';
        el.style.visibility = 'hidden';
        el.classList.remove('is-open', 'is-visible');
      }
    });

    // Get or create content wrapper
    let content = container.querySelector('.search-results__content') || 
                  container.querySelector('.unified-search-content');
    
    if (!content) {
      content = document.createElement('div');
      content.className = 'search-results__content unified-search-content';
      container.innerHTML = '';
      container.appendChild(content);
    }

    container._contentWrapper = content;
    return container;
  }

  async performUnifiedSearch(query, input, container) {
    if (this.isSearching) return;
    
    // Don't search if query is empty or too short
    const trimmedQuery = query.trim();
    if (!trimmedQuery || trimmedQuery.length < 1) {
      this.showEmptyState(input, container);
      return;
    }
    
    this.isSearching = true;

    try {
      // Get corrected query first
      const corrected = this.autoCorrect(trimmedQuery);
      
      // Get suggestions (will include corrections)
      let suggestions = this.getSuggestions(trimmedQuery);
      
      console.log('Raw suggestions:', suggestions);
      
      // If we have a correction, add it to suggestions if not already there
      if (corrected && corrected !== trimmedQuery) {
        if (!suggestions.includes(corrected)) {
          suggestions.unshift(corrected);
        }
      }
      
      // Remove duplicates and limit to 8
      suggestions = [...new Set(suggestions)].slice(0, 8);
      
      console.log('Final suggestions (unique):', suggestions);
      
      // Use corrected query for product search - only if query is 2+ characters
      const searchQuery = corrected || trimmedQuery;
      let products = [];
      let collections = [];

      // Only fetch products if query is 2+ characters
      if (searchQuery.length >= 2) {
        // Fetch products with corrected query (in parallel)
        const [productsResponse] = await Promise.allSettled([
          fetch(
            `/search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`
          )
        ]);

        if (productsResponse.status === 'fulfilled' && productsResponse.value.ok) {
          const data = await productsResponse.value.json();
          products = data.resources?.results?.products || [];
          collections = data.resources?.results?.collections || [];
        }
      }

      console.log('Products found:', products.length);
      console.log('Suggestions to display:', suggestions.length);

      // Display unified results - ALWAYS show suggestions if we have them
      this.displayUnifiedResults(trimmedQuery, corrected, suggestions, products, collections, container);
    } catch (error) {
      console.error('Search error:', error);
      this.showNoResults(trimmedQuery, container);
    } finally {
      this.isSearching = false;
    }
  }

  getSuggestions(query) {
    if (!query || query.trim().length < 1) {
      return [];
    }
    
    const lowerQuery = query.toLowerCase().trim();
    const suggestions = new Set();
    const scoredSuggestions = [];

    // 1. Direct dictionary matches (exact typos) - highest priority
    if (this.autoCorrectDictionary[lowerQuery]) {
      const corrected = this.autoCorrectDictionary[lowerQuery];
      if (!suggestions.has(corrected)) {
        suggestions.add(corrected);
        scoredSuggestions.push({ term: corrected, score: 100, isCorrected: true });
      }
    }

    // 2. Popular searches that start with query (high priority) - even for 1 character
    this.popularSearches.forEach(term => {
      const lowerTerm = term.toLowerCase();
      if (lowerTerm.startsWith(lowerQuery) && !suggestions.has(term)) {
        suggestions.add(term);
        scoredSuggestions.push({ term: term, score: 90, isCorrected: false });
      }
    });

    // 3. Popular searches that contain query (but don't start with it)
    if (lowerQuery.length > 1) {
      this.popularSearches.forEach(term => {
        const lowerTerm = term.toLowerCase();
        if (lowerTerm.includes(lowerQuery) && !suggestions.has(term) && !lowerTerm.startsWith(lowerQuery)) {
          suggestions.add(term);
          scoredSuggestions.push({ term: term, score: 70, isCorrected: false });
        }
      });
    }

    // 4. Dictionary corrections (fuzzy matching for typos)
    for (const [wrong, correct] of Object.entries(this.autoCorrectDictionary)) {
      if (suggestions.has(correct)) continue;
      
      const similarity = this.calculateSimilarity(lowerQuery, wrong);
      if (similarity > 0.6 && similarity < 1.0) {
        suggestions.add(correct);
        scoredSuggestions.push({ term: correct, score: 80, isCorrected: true });
      }
    }

    // 5. Fuzzy matching with popular searches
    if (lowerQuery.length > 1) {
      this.popularSearches.forEach(term => {
        if (suggestions.has(term)) return;
        
        const lowerTerm = term.toLowerCase();
        const similarity = this.calculateSimilarity(lowerQuery, lowerTerm);
        if (similarity > 0.7 && similarity < 1.0) {
          suggestions.add(term);
          scoredSuggestions.push({ term: term, score: 60, isCorrected: false });
        }
      });
    }

    // Sort by score and return top suggestions
    scoredSuggestions.sort((a, b) => b.score - a.score);
    const result = scoredSuggestions.slice(0, 8).map(s => s.term);
    
    // Debug logging
    console.log('getSuggestions for "' + query + '" returned:', result);
    
    return result;
  }

  displayUnifiedResults(originalQuery, corrected, suggestions, products, collections, container) {
    const content = container._contentWrapper || container.querySelector('.search-results__content') || container;
    if (!content) {
      console.error('No content container found');
      return;
    }
    
    const isMobile = window.innerWidth <= 749;
    let html = '';
    const hasCorrection = corrected && corrected !== originalQuery;
    const queryLength = originalQuery.trim().length;

    // Remove duplicates from suggestions
    const uniqueSuggestions = suggestions ? [...new Set(suggestions.filter(s => s))] : [];

    console.log('Displaying unified results:', {
      query: originalQuery,
      corrected: corrected,
      suggestionsCount: uniqueSuggestions.length,
      productsCount: products ? products.length : 0,
      hasCorrection: hasCorrection
    });

    // 1. RECENT SEARCHES SECTION (show when query is empty)
    if (queryLength === 0 && this.recentSearches.length > 0) {
      html += '<div class="unified-search-section unified-search-recent">';
      html += '<div class="unified-search-section-header">';
      html += '<span>RECENT SEARCHES</span>';
      if (isMobile) {
        html += '<button type="button" class="unified-search-close-btn" aria-label="Close search results">';
        html += '<svg width="18" height="18" viewBox="0 0 18 18" fill="none">';
        html += '<path d="M13.5 4.5L4.5 13.5M4.5 4.5l9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>';
        html += '</svg>';
        html += '</button>';
      }
      html += '</div>';
      html += '<div class="unified-search-recent-list">';
      
      this.recentSearches.slice(0, 5).forEach(term => {
        html += `
          <button type="button" class="unified-search-recent-item" data-suggestion="${term}">
            <svg class="unified-search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 2L2 6l4 4M10 2l4 4-4 4" stroke="currentColor" stroke-width="1.33" stroke-linecap="round"/>
            </svg>
            <span>${term}</span>
          </button>
        `;
      });
      
      html += '</div></div>';
    }

    // 2. POPULAR SEARCHES / SUGGESTIONS SECTION
    // If query is empty, show popular searches (after recent searches)
    if (queryLength === 0) {
      html += '<div class="unified-search-section unified-search-popular">';
      html += '<div class="unified-search-section-header">';
      html += '<span>POPULAR SEARCHES</span>';
      if (isMobile) {
        html += '<button type="button" class="unified-search-close-btn" aria-label="Close search results">';
        html += '<svg width="18" height="18" viewBox="0 0 18 18" fill="none">';
        html += '<path d="M13.5 4.5L4.5 13.5M4.5 4.5l9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>';
        html += '</svg>';
        html += '</button>';
      }
      html += '</div>';
      html += '<div class="unified-search-popular-list">';
      
      this.popularSearches.slice(0, 8).forEach(term => {
        html += `
          <button type="button" class="unified-search-popular-item" data-suggestion="${term}">
            <svg class="unified-search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" stroke-width="1.33"/>
              <path d="M14 14L11.1 11.1" stroke="currentColor" stroke-width="1.33" stroke-linecap="round"/>
            </svg>
            <span>${term}</span>
          </button>
        `;
      });
      
      html += '</div></div>';
    } else if (uniqueSuggestions.length > 0) {
      // Has query - show suggestions
      html += '<div class="unified-search-section unified-search-suggestions">';
      html += '<div class="unified-search-section-header">';
      html += '<span>POPULAR SEARCHES</span>';
      if (isMobile) {
        html += '<button type="button" class="unified-search-close-btn" aria-label="Close search results">';
        html += '<svg width="18" height="18" viewBox="0 0 18 18" fill="none">';
        html += '<path d="M13.5 4.5L4.5 13.5M4.5 4.5l9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>';
        html += '</svg>';
        html += '</button>';
      }
      html += '</div>';
      html += '<div class="unified-search-suggestions-list">';
      
      uniqueSuggestions.forEach(suggestion => {
        if (!suggestion) return;
        const isCorrected = hasCorrection && suggestion === corrected;
        
        html += `
          <button type="button" class="unified-search-suggestion-item ${isCorrected ? 'unified-search-corrected' : ''}" 
                  data-suggestion="${suggestion}">
            <svg class="unified-search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" stroke-width="1.33"/>
              <path d="M14 14L11.1 11.1" stroke="currentColor" stroke-width="1.33" stroke-linecap="round"/>
            </svg>
            <span class="unified-search-suggestion-text">${this.highlightMatch(suggestion, originalQuery)}</span>
            ${isCorrected ? '<span class="unified-search-corrected-badge">Corrected</span>' : ''}
          </button>
        `;
      });
      
      html += '</div></div>';
    }

    // 3. PRODUCTS SECTION (Redline style - shows after suggestions)
    // Only show products if query is 2+ characters
    if (products.length > 0 && queryLength >= 2) {
      html += '<div class="unified-search-section unified-search-products">';
      html += '<div class="unified-search-section-header">PRODUCTS</div>';
      html += '<div class="unified-search-products-list">';
      
      products.forEach(product => {
        const image = product.featured_image?.url || product.image || '';
        const price = product.price ? this.formatPrice(product.price) : '';
        const url = product.url || '';
        const title = product.title || '';
        
        html += `
          <a href="${url}" class="unified-search-product-item">
            ${image ? `<img src="${image}" alt="${title}" class="unified-search-product-image" loading="lazy">` : 
              `<div class="unified-search-product-placeholder">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>`
            }
            <div class="unified-search-product-info">
              <h4 class="unified-search-product-title">${this.highlightMatch(title, originalQuery)}</h4>
              ${price ? `<span class="unified-search-product-price">${price}</span>` : ''}
            </div>
          </a>
        `;
      });
      
      html += '</div></div>';
    }

    // 4. COLLECTIONS SECTION
    // Only show collections if query is 2+ characters
    if (collections.length > 0 && queryLength >= 2) {
      html += '<div class="unified-search-section unified-search-collections">';
      html += '<div class="unified-search-section-header">CATEGORIES</div>';
      html += '<div class="unified-search-collections-list">';
      
      collections.forEach(collection => {
        const image = collection.image || collection.featured_image || '';
        const url = collection.url || '';
        const title = collection.title || '';
        
        html += `
          <a href="${url}" class="unified-search-collection-item">
            ${image ? `<img src="${image}" alt="${title}" class="unified-search-collection-image" loading="lazy">` : ''}
            <span class="unified-search-collection-title">${this.highlightMatch(title, originalQuery)}</span>
          </a>
        `;
      });
      
      html += '</div></div>';
    }

    // 5. VIEW ALL LINK (Redline style - at bottom)
    // Only show "View All" if query is 2+ characters and we have results
    if ((products.length > 0 || collections.length > 0) && queryLength >= 2) {
      const displayQuery = corrected && corrected !== originalQuery ? corrected : originalQuery;
      html += `
        <div class="unified-search-footer">
          <a href="/search?q=${encodeURIComponent(displayQuery)}" class="unified-search-view-all">
            Show all results for: "${displayQuery}"
          </a>
        </div>
      `;
    }

    // Show no results if nothing found
    if (uniqueSuggestions.length === 0 && products.length === 0 && collections.length === 0) {
      html = `
        <div class="unified-search-no-results">
          <p>No results found for "${originalQuery}"</p>
          <p class="unified-search-suggestions-text">
            Try: <a href="/search?q=headlight">headlight</a>, 
            <a href="/search?q=taillight">taillight</a>, 
            <a href="/search?q=bumper">bumper</a>
          </p>
        </div>
      `;
    }

    // Only show if there's actual content
    if (html.trim().length > 0) {
      content.innerHTML = html;
      this.showResults(container);
    } else {
      // Hide if no content to prevent empty box
      content.innerHTML = '';
      this.hideResults(container);
    }

    // Add event listeners - need to get input from container context
    // Try multiple ways to find the input
    let input = container.closest('.header__search')?.querySelector('[data-search-input]') ||
                container.closest('.header__mobile-search')?.querySelector('.header__mobile-search-input') ||
                container.closest('.header__mobile-search')?.querySelector('#mobile-search-input') ||
                container.closest('form')?.querySelector('input[name="q"]') ||
                container.closest('form')?.querySelector('input[type="search"]') ||
                document.querySelector('[data-search-input]') ||
                document.querySelector('.header__mobile-search-input') ||
                document.querySelector('#mobile-search-input');
    
    if (input) {
      this.attachEventListeners(input, container);
    } else {
      console.warn('Input not found for container:', container);
    }
    
    // Add mobile close button handler
    const closeBtn = container.querySelector('.unified-search-close-btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.hideResults(container);
        if (input) {
          input.blur();
        }
      });
    }
  }

  attachEventListeners(input, container) {
    // Use event delegation for better reliability
    const handleSuggestionClick = (e) => {
      // Check if clicked element or its parent is a suggestion item
      const item = e.target.closest('.unified-search-suggestion-item, .unified-search-recent-item, .unified-search-popular-item');
      
      if (!item) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      // Get suggestion from data attribute or text content
      let suggestion = item.dataset.suggestion;
      
      // If no data attribute, extract from text content
      if (!suggestion) {
        const suggestionSpan = item.querySelector('span');
        if (suggestionSpan) {
          suggestion = suggestionSpan.textContent.trim();
        } else {
          // Get all text, excluding SVG icons
          const clone = item.cloneNode(true);
          clone.querySelectorAll('svg').forEach(svg => svg.remove());
          suggestion = clone.textContent.trim();
        }
      }
      
      // Clean up suggestion text
      suggestion = suggestion.replace(/\s+/g, ' ').trim();
      
      if (suggestion && input) {
        console.log('Suggestion clicked/touched:', suggestion);
        
        // Focus the input first to ensure hover/focus checks pass
        input.focus();
        
        // Fill the input with the suggestion
        input.value = suggestion;
        
        // Update clear button visibility
        const clearButton = input.parentElement?.querySelector('.search-clear, [data-clear-search]');
        if (clearButton && suggestion.length > 0) {
          clearButton.style.display = 'flex';
        }
        
        // Save to recent searches
        this.saveRecentSearch(suggestion);
        
        // Find the search form and submit button
        const form = input.closest('form');
        const searchButton = form?.querySelector('button[type="submit"]') || 
                             form?.querySelector('.search-button') ||
                             form?.querySelector('.header__mobile-search-button');
        
        // Auto-trigger search button click to submit the form
        if (searchButton && form) {
          // Small delay to ensure input value is set
          setTimeout(() => {
            console.log('Auto-triggering search button for:', suggestion);
            searchButton.click();
          }, 50);
        } else {
          // Fallback: perform unified search if button not found
          setTimeout(() => {
            this.performUnifiedSearch(suggestion, input, container).then(() => {
              console.log('Search completed for:', suggestion);
            }).catch(err => {
              console.error('Search error:', err);
            });
          }, 10);
        }
        
        // Also dispatch input event for any other handlers that might be listening
        const inputEvent = new Event('input', { bubbles: true, cancelable: true });
        input.dispatchEvent(inputEvent);
      }
    };
    
    // Remove old listeners if they exist
    if (container._suggestionClickHandler) {
      container.removeEventListener('click', container._suggestionClickHandler);
      container.removeEventListener('touchstart', container._suggestionClickHandler);
    }
    
    // Add event listeners using delegation (on container)
    // Remove old listeners if they exist
    if (container._suggestionClickHandler) {
      container.removeEventListener('click', container._suggestionClickHandler, true);
      container.removeEventListener('touchend', container._suggestionClickHandler, true);
    }
    
    container._suggestionClickHandler = handleSuggestionClick;
    
    // Add click handler (works for desktop mouse clicks)
    container.addEventListener('click', handleSuggestionClick, true);
    
    // Add touchend handler for mobile (fires after touch, before click)
    // Use touchend instead of touchstart to allow natural touch behavior
    container.addEventListener('touchend', (e) => {
      const item = e.target.closest('.unified-search-suggestion-item, .unified-search-recent-item, .unified-search-popular-item');
      if (item) {
        // Prevent click from also firing
        e.preventDefault();
        handleSuggestionClick(e);
      }
    }, { passive: false, capture: true });

    // Product clicks - close dropdown after navigation
    container.querySelectorAll('.unified-search-product-item, .unified-search-collection-item').forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        // Close immediately on click
        this.hideResults(container);
      });
    });
    
    // View all link - close dropdown
    container.querySelectorAll('.unified-search-view-all').forEach(link => {
      link.addEventListener('click', (e) => {
        e.stopPropagation();
        // Close immediately on click
        this.hideResults(container);
      });
    });
  }

  showEmptyState(input, container) {
    // Only show if input is focused or being hovered
    const isFocused = document.activeElement === input;
    const isHovering = input.matches(':hover') || (input.closest('form') && input.closest('form').matches(':hover'));
    
    if (!isFocused && !isHovering) {
      // Don't show if not actively interacting
      this.hideResults(container);
      return;
    }
    
    const isMobile = window.innerWidth <= 749;
    const content = container._contentWrapper || container.querySelector('.search-results__content') || container;
    let html = '';
    
    // 1. RECENT SEARCHES SECTION (if any)
    if (this.recentSearches.length > 0) {
      html += '<div class="unified-search-section unified-search-recent">';
      html += '<div class="unified-search-section-header">';
      html += '<span>RECENT SEARCHES</span>';
      if (isMobile) {
        html += '<button type="button" class="unified-search-close-btn" aria-label="Close search results">';
        html += '<svg width="18" height="18" viewBox="0 0 18 18" fill="none">';
        html += '<path d="M13.5 4.5L4.5 13.5M4.5 4.5l9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>';
        html += '</svg>';
        html += '</button>';
      }
      html += '</div>';
      html += '<div class="unified-search-recent-list">';
      
      this.recentSearches.slice(0, 5).forEach(term => {
        html += `
          <button type="button" class="unified-search-recent-item" data-suggestion="${term}">
            <svg class="unified-search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 2L2 6l4 4M10 2l4 4-4 4" stroke="currentColor" stroke-width="1.33" stroke-linecap="round"/>
            </svg>
            <span>${term}</span>
          </button>
        `;
      });
      
      html += '</div></div>';
    }
    
    // 2. POPULAR SEARCHES SECTION
    html += '<div class="unified-search-section unified-search-popular">';
    html += '<div class="unified-search-section-header">';
    html += '<span>POPULAR SEARCHES</span>';
    if (isMobile) {
      html += '<button type="button" class="unified-search-close-btn" aria-label="Close search results">';
      html += '<svg width="18" height="18" viewBox="0 0 18 18" fill="none">';
      html += '<path d="M13.5 4.5L4.5 13.5M4.5 4.5l9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>';
      html += '</svg>';
      html += '</button>';
    }
    html += '</div>';
    html += '<div class="unified-search-popular-list">';
    html += this.popularSearches.slice(0, 8).map(term => `
      <button type="button" class="unified-search-popular-item" data-suggestion="${term}">
        <svg class="unified-search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" stroke-width="1.33"/>
          <path d="M14 14L11.1 11.1" stroke="currentColor" stroke-width="1.33" stroke-linecap="round"/>
        </svg>
        <span>${term}</span>
      </button>
    `).join('');
    html += '</div></div>';
    
    content.innerHTML = html;
    this.showResults(container);
    if (input) {
      this.attachEventListeners(input, container);
    }
    
    // Add mobile close button handler
    const containerElement = input?.closest('form')?.querySelector('#mobile-search-results') ||
                             input?.closest('form')?.querySelector('#search-results') ||
                             document.querySelector('#mobile-search-results') ||
                             document.querySelector('#search-results');
    if (containerElement) {
      const closeBtn = containerElement.querySelector('.unified-search-close-btn');
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.hideResults(containerElement);
          if (input) {
            input.blur();
          }
        });
      }
    }
  }

  showNoResults(query, container) {
    const content = container._contentWrapper || container.querySelector('.search-results__content') || container;
    content.innerHTML = `
      <div class="unified-search-no-results">
        <p>No results found for "${query}"</p>
        <p class="unified-search-suggestions-text">
          Try: <a href="/search?q=headlight">headlight</a>, 
          <a href="/search?q=taillight">taillight</a>, 
          <a href="/search?q=bumper">bumper</a>
        </p>
      </div>
    `;
    this.showResults(container);
  }

  autoCorrect(query) {
    const lowerQuery = query.toLowerCase().trim();
    
    if (this.autoCorrectDictionary[lowerQuery]) {
      return this.autoCorrectDictionary[lowerQuery];
    }

    let bestMatch = null;
    let bestScore = 0;

    for (const [wrong, correct] of Object.entries(this.autoCorrectDictionary)) {
      const similarity = this.calculateSimilarity(lowerQuery, wrong);
      if (similarity > bestScore && similarity > 0.7) {
        bestScore = similarity;
        bestMatch = correct;
      }
    }

    if (bestMatch) return bestMatch;

    // Pattern-based corrections
    let corrected = query;
    corrected = corrected.replace(/hedlight(s?)/gi, 'headlight$1');
    corrected = corrected.replace(/tailight(s?)/gi, 'taillight$1');
    corrected = corrected.replace(/windshild/gi, 'windshield');
    corrected = corrected.replace(/bumer/gi, 'bumper');
    corrected = corrected.replace(/miror(s?)/gi, 'mirror$1');
    corrected = corrected.replace(/singal(s?)/gi, 'signal$1');
    corrected = corrected.replace(/\bhead\s+light(s?)\b/gi, 'headlight$1');
    corrected = corrected.replace(/\btail\s+light(s?)\b/gi, 'taillight$1');
    corrected = corrected.replace(/\bfog\s+light(s?)\b/gi, 'foglight$1');
    corrected = corrected.replace(/\bbrake\s+light(s?)\b/gi, 'brakelight$1');

    return corrected.trim();
  }

  calculateSimilarity(str1, str2) {
    const longer = str1.length > str2.length ? str1 : str2;
    const shorter = str1.length > str2.length ? str2 : str1;
    if (longer.length === 0) return 1.0;
    const distance = this.levenshteinDistance(longer, shorter);
    return (longer.length - distance) / longer.length;
  }

  levenshteinDistance(str1, str2) {
    const matrix = [];
    for (let i = 0; i <= str2.length; i++) {
      matrix[i] = [i];
    }
    for (let j = 0; j <= str1.length; j++) {
      matrix[0][j] = j;
    }
    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }
    return matrix[str2.length][str1.length];
  }

  highlightMatch(text, query) {
    if (!query) return text;
    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    return text.replace(regex, '<mark>$1</mark>');
  }

  saveRecentSearch(term) {
    if (!term || term.length < 2) return;
    this.recentSearches = this.recentSearches.filter(t => t !== term);
    this.recentSearches.unshift(term);
    this.recentSearches = this.recentSearches.slice(0, 10);
    localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
  }

  loadRecentSearches() {
    try {
      const stored = localStorage.getItem('recentSearches');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  showResults(container) {
    if (container) {
      container.setAttribute('aria-hidden', 'false');
      container.classList.add('is-visible', 'unified-search-results');
      
      // Ensure form has relative positioning for absolute dropdown
      const form = container.closest('form');
      const searchArea = container.closest('.header__mobile-search') || container.closest('.header__search');
      
      if (form) {
        form.style.position = 'relative';
      }
      if (searchArea) {
        searchArea.style.position = 'relative';
      }
      
      // Use absolute positioning for both desktop and mobile (like desktop)
      container.style.position = 'absolute';
      container.style.top = '100%';
      container.style.left = '0';
      container.style.right = '0';
      container.style.width = '100%';
      container.style.display = 'block';
      container.style.visibility = 'visible';
      container.style.opacity = '1';
      container.style.marginTop = '1px';
      container.style.zIndex = '10000';
      
      // Remove any fixed positioning styles
      container.style.removeProperty('transform');
      
      // Remove scroll listeners if they exist (from old fixed positioning)
      if (container._scrollListener) {
        window.removeEventListener('scroll', container._scrollListener);
        window.removeEventListener('resize', container._scrollListener);
        container._scrollListener = null;
      }
      
      // Force show with inline style
      const currentStyle = container.getAttribute('style') || '';
      container.setAttribute('style', currentStyle + ' display: block !important; visibility: visible !important; opacity: 1 !important;');
      
      // Hide old separate containers
      const oldContainers = document.querySelectorAll('.search-products, .search-collections, .search-view-all, #search-loading, #search-no-results');
      oldContainers.forEach(el => {
        if (el) el.style.display = 'none';
      });
    } else {
      console.error('showResults called but container is null!');
    }
  }

  hideResults(container) {
    if (container) {
      container.setAttribute('aria-hidden', 'true');
      container.classList.remove('is-visible');
      
      // Force hide with all properties - clear all inline styles that might show it
      container.style.cssText = 'display: none !important; opacity: 0 !important; visibility: hidden !important; transform: translateY(-10px) !important;';
      
      // Clear content to prevent empty box showing
      const content = container.querySelector('.search-results__content');
      if (content) {
        content.innerHTML = '';
      }
      
      // Remove suggestion click handlers
      if (container._suggestionClickHandler) {
        container.removeEventListener('click', container._suggestionClickHandler, true);
        container.removeEventListener('touchend', container._suggestionClickHandler, true);
        container._suggestionClickHandler = null;
      }
      
      // Remove mobile close handlers
      if (container._mobileCloseHandler) {
        document.removeEventListener('click', container._mobileCloseHandler, true);
        document.removeEventListener('touchstart', container._mobileCloseHandler, true);
        container._mobileCloseHandler = null;
      }
      
      // Remove scroll listeners on mobile
      if (container._scrollListener) {
        window.removeEventListener('scroll', container._scrollListener);
        window.removeEventListener('resize', container._scrollListener);
        container._scrollListener = null;
      }
    }
  }

  formatPrice(price) {
    if (!price || price === 0) return '';
    const dollars = typeof price === 'number' ? price / 100 : parseFloat(price) / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(dollars);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize when DOM is ready
function initUnifiedSearch() {
  // Wait a bit to ensure all elements are ready
  setTimeout(() => {
    try {
      const search = new UnifiedSearch();
      console.log('UnifiedSearch initialized with', search.searchInputs.length, 'input(s)');
      
      // Debug: Check if container exists
      const container = document.querySelector('#search-results');
      if (container) {
        console.log('Search container found:', container);
        console.log('Container classes:', container.className);
        console.log('Container display:', window.getComputedStyle(container).display);
      } else {
        console.warn('Search container #search-results not found!');
      }
    } catch (error) {
      console.error('Error initializing UnifiedSearch:', error);
    }
  }, 200);
}

// Initialize immediately and also on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUnifiedSearch);
} else {
  initUnifiedSearch();
}

// Also try after a delay in case elements load late
setTimeout(initUnifiedSearch, 500);
